// extracted by mini-css-extract-plugin
export default {"items":"DragDropItems__items--S1hduvwBScuMwpq_yURU","isDraggingOver":"DragDropItems__isDraggingOver--Bq_AeVQuSMKNwueuhK_o"};